import React, { createContext, useEffect, useRef } from "react";
import { useState } from "react";
import {
  getPartRequestList,
  issuePartsFromPartRequest,
} from "../Services/partRequestService";
import { HTTP_RESPONSE_CODES } from "../../../globals/globals";
import { useSnackBar } from "../../../hooks/useSnackBar";
import { use } from "react";

const PartRequestContext = createContext();

const PartRequestProvider = ({ children }) => {
  const [loadingPartsReq, setLoadingPartsReq] = useState(true);
  const [tabIndex, setTabIndex] = React.useState(0);
  const [page, setPage] = useState(0);
  const [maxPages, setMaxPages] = useState(null);
  const [sortingOrder, setSortingOrder] = useState("id");
  const [partRequestList, setPartRequestList] = useState([]);
  const [partsRequestToIssue, setPartsRequestToIssue] = useState([]);
  const [filters, setFilters] = useState({ dropdowns: {}, txt: {} });
  const [partsIssuedDate, setPartsIssuedDate] = useState(null);
  const { successMsg, warningMsg, infoMsg } = useSnackBar();
  const [search, setSearch] = useState("");
  const didMount = useRef(false);
  const pageSize = 10;
  const [typeRequestTab , setTypeRequestTab] = useState("Workpackage")
  const [totalPRWorkpackage , setTotalPRWorkpackage] = useState(0)
  const [totalPRTransfer , setTotalPRTransfer] = useState(0)


 const onSearch = (value) => {
    setSearch(value);
  };
  const mapToIssueRequestDTO = (partsRequestToIssue, rackId, employeeSelected) => {
    const grouped = {};

    for (const item of partsRequestToIssue) {
      if (!grouped[item.part_request_id]) {
        grouped[item.part_request_id] = {
          partRequestId: item.part_request_id,
          companyId: item.company_id,
          employeeId: employeeSelected,
          rackId: rackId,
          details: [],
        };
      }

      grouped[item.part_request_id].details.push({
        id: item.id,
        serializedPartId: item.serialized_part_id_selected ?? null,
        siteId: item.site_id,
        rackId: item.rack_id,
        binId: item.bin_id,
        shelfId: item.shelf_id,
        locationId: item.location_id,
        quantityToIssue: item.quantity_issue,
        partId: item.part_id,
        companyId: item.company_id,
        referenceType: item.reference_type,
        referenceId: item.reference_id,
        partRequestDetailId: item.detail_id,
        uomId: item.uom_id,
        internalBatch: item.internal_batch,
      });
    }

    return Object.values(grouped);
  };
  const onFiltersChange = (dropdownFilters, txtFilters) => {
    setFilters({
      dropdowns: dropdownFilters,
      txt: txtFilters,
    });
  };

  const handleTypeRequestSelectionTab = (tab)=>{
    setTypeRequestTab(tab)
  }
  useEffect(() => {

    setPage(0);
    setLoadingPartsReq(true);
    getPartRequestList(
      page,
      pageSize,
      sortingOrder,
      search,
      filters,
      typeRequestTab
    )
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
          setMaxPages(response.data.totalPages);
          setTotalPRWorkpackage(response.data.auxiliarInformation.countView0)
          setTotalPRTransfer(response.data.auxiliarInformation.countView1)

          let partRequestArray = response.data.load.map((item) => ({
            ...item,
          }));
          setPartRequestList((prev) =>
            page > 0 ? [...prev, ...partRequestArray] : [...partRequestArray]
          );
          setLoadingPartsReq(false);
        }
      })
      .catch((error) => setLoadingPartsReq(false));
  }, [tabIndex , typeRequestTab]);
  useEffect(() => {

    setLoadingPartsReq(true);
    getPartRequestList(
      page,
      pageSize,
      sortingOrder,
      search,
      filters
    )
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
          setMaxPages(response.data.totalPages);
          let partRequestArray = response.data.load.map((item) => ({
            ...item,
          }));
          setPartRequestList((prev) =>
            page > 0 ? [...prev, ...partRequestArray] : [...partRequestArray]
          );
          setLoadingPartsReq(false);
        }
      })
      .catch((error) => setLoadingPartsReq(false));
  }, [filters, page, search, sortingOrder]);

  const requestNextPage = () => {
    setPage((prev) => Math.min(prev + 1, maxPages - 1));
  };

  const issueParts = async (rackId, employeeId) => {
    if (partsRequestToIssue.length == 0) return;
    const payload = mapToIssueRequestDTO(partsRequestToIssue, rackId, employeeId);
    issuePartsFromPartRequest(payload)
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
          successMsg("Parts Were issued successfully");
          setPartsIssuedDate(new Date());
          setPartsRequestToIssue([]);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {});
  };

  return (
    <PartRequestContext.Provider
      value={{
        setTabIndex,
        tabIndex,
        setLoadingPartsReq,
        loadingPartsReq,
        requestNextPage,
        setSortingOrder,
        partRequestList,
        setPartsRequestToIssue,
        onSearch,
        partsRequestToIssue,
        issueParts,
        partsIssuedDate,
        page,
        typeRequestTab,
        handleTypeRequestSelectionTab,
        totalPRWorkpackage,
        totalPRTransfer
      }}
    >
      {children}
    </PartRequestContext.Provider>
  );
};

export { PartRequestContext, PartRequestProvider };
